const LOW_STOCK_READ_KEY = 'adminLowStockNotificationsRead';
export const LOW_STOCK_READ_EVENT = 'admin-low-stock-notifications-read';

const loadReadMap = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(LOW_STOCK_READ_KEY) || '{}');
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
};

const saveReadMap = (map) => {
  localStorage.setItem(LOW_STOCK_READ_KEY, JSON.stringify(map));
  window.dispatchEvent(new CustomEvent(LOW_STOCK_READ_EVENT));
};

export const getNotificationReadKey = (item) => `${item.id}:${item.stock}`;

export const isLowStockNotificationRead = (item) => {
  const readMap = loadReadMap();
  return Boolean(readMap[getNotificationReadKey(item)]);
};

export const markLowStockNotificationRead = (item) => {
  const readMap = loadReadMap();
  readMap[getNotificationReadKey(item)] = new Date().toISOString();
  saveReadMap(readMap);
};

export const markLowStockNotificationsRead = (items) => {
  const readMap = loadReadMap();
  (items || []).forEach((item) => {
    readMap[getNotificationReadKey(item)] = new Date().toISOString();
  });
  saveReadMap(readMap);
};

export const countUnreadLowStockNotifications = (items) => {
  const readMap = loadReadMap();
  return (items || []).filter((item) => !readMap[getNotificationReadKey(item)]).length;
};
